import { ref } from 'vue';
import type { Options } from '@/components/w-tooltip/w-tooltip.types';

const shouldTooltipShow = ref(false);
const tooltipTrigger = ref<HTMLElement | null>(null);
const tooltipOptions = ref<Options | null>(null);
const isTooltipHovered = ref(false);

type ShowTooltipOptions = {
  trigger: HTMLElement;
  options: Options;
};

export const useWTooltip = () => {
  return {
    shouldTooltipShow,
    tooltipOptions,
    tooltipTrigger,
    isTooltipHovered,
    showTooltip: (opts: ShowTooltipOptions) => {
      tooltipTrigger.value = opts.trigger;
      tooltipOptions.value = opts.options;
      shouldTooltipShow.value = true;
    },
    hideTooltip: () => {
      shouldTooltipShow.value = false;
    },
    setIsTooltipHovered: (value: boolean) => {
      isTooltipHovered.value = value;
    },
  };
};

export const wTooltipInstanceExists = ref(false);
